'use strict';

var TrendChartPanelDirective = function TrendChartPanelDirective($timeout) {
  return {
    restrict: 'E',
    template: require('../templates/trend-chart-panel.html'),
    scope: {
      screen: '@',
      mode: '@',
      isChartVisible: '='
    },
    link: function link($scope, element) {
      $scope.setChartVisibility = function (show) {
        $scope.isChartVisible = show;
        element.toggleClass('collapsed', !show);
      };
      $scope.toggleChartVisibility = function () {
        $scope.setChartVisibility(!$scope.isChartVisible);
        if ($scope.isChartVisible) {
          $timeout(function () {
            $scope.$broadcast('rom-analysis-panel:uncollapseTrendChart');
          }, 0);
        }
      };
    }
  };
};
TrendChartPanelDirective.$inject = ['$timeout'];
module.exports = TrendChartPanelDirective;